export default __webpack_public_path__ + "assets/video_play_button.75b944d8.svg";